var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClipboardCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_768_30224)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 30.27L15.615 24.885L13.5 27L21 34.5L34.5 21L32.385 18.87L21 30.27Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5 7.5H33V6C33 4.35 31.65 3 30 3H18C16.35 3 15 4.35 15 6V7.5H10.5C8.85 7.5 7.5 8.85 7.5 10.5V42C7.5 43.65 8.85 45 10.5 45H37.5C39.15 45 40.5 43.65 40.5 42V10.5C40.5 8.85 39.15 7.5 37.5 7.5ZM18 6H30V12H18V6ZM37.5 42H10.5V10.5H15V15H33V10.5H37.5V42Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_768_30224"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboardCheck);
export default __webpack_public_path__ + "static/media/clipboard-check.88c2e9da4a27ac2f53b032d25180a8d6.svg";
export { ForwardRef as ReactComponent };